import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  text: {
    default: 'The Access Group',
    editor: 'textbox',
  },
  href: {
    default: 'https://www.theaccessgroup.com/',
    editor: 'textbox',
  },
  target: {
    default: '_blank',
    editor: 'textbox',
  },
  accent: {
    default: 'viridiangreen',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-link where you can change all the attributes',
  coreComponent: {
    html: `<tag-link{{...knobs}}>
</tag-link>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper: { jsx: `<TagLink{{...knobs}} />`, knobs: PlaygroundKnobs },
  coreComponent_v3: {
    html: `<tag3-link{{...knobs}}>
</tag3-link>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: { jsx: `<Tag3Link{{...knobs}} />`, knobs: PlaygroundKnobs },
};

export const TagLinkDocs: Component = {
  type: 'component',
  name: 'link',
  description: 'Renders a hyperlink',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'text',
      description: 'The text for the link',
      type: 'string',
    },
    {
      name: 'name',
      description: 'The name',
      type: 'string',
    },
    {
      name: 'href',
      description: 'The location',
      type: 'string',
    },
    {
      name: 'target',
      description: 'The target',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The text colour',
      type: 'Accent',
      default: 'viridiangreen',
    },
    {
      name: 'linkStyle',
      description: 'JSX style object in JSON to apply to the link',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory],
};
